'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _styles = require('../nitro-select/styles');

var _styles2 = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroSingleSelect = function (_Component) {
  _inherits(NitroSingleSelect, _Component);

  function NitroSingleSelect(props) {
    _classCallCheck(this, NitroSingleSelect);

    var _this = _possibleConstructorReturn(this, (NitroSingleSelect.__proto__ || Object.getPrototypeOf(NitroSingleSelect)).call(this, props));

    _this.handleClickAway = function (e) {
      var select = _this.root;
      if (!select.contains(e.target)) {
        _this.setState({
          open: false
        });
      }
    };

    _this.handleOptionSelect = function (option) {
      _this.props.action(option);
      _this.setState({
        open: false
      });
    };

    _this.clearSelected = function () {
      _this.props.action({ label: '', value: '' });
    };

    _this.toggleOpen = function (event) {
      _this.setState({
        open: !_this.state.open
      });

      event.stopPropagation();
      event.preventDefault();
    };

    _this.state = {
      open: false
    };
    return _this;
  }

  _createClass(NitroSingleSelect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickAway, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickAway, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          containerMaxHeight = _props.containerMaxHeight,
          disabled = _props.disabled,
          mandatory = _props.mandatory,
          options = _props.options,
          placeholder = _props.placeholder,
          value = _props.value;


      var selected = options.find(function (option) {
        return option.value === value;
      });
      var label = selected ? selected.label : '';

      var iconName = this.state.open ? 'arrow-up-solid' : 'arrow-down-solid';

      var hideClear = mandatory || !selected;

      var isEmptyValue = false;
      if (value) {
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && Object.keys(value).length === 0) {
          isEmptyValue = true;
        }
      } else {
        isEmptyValue = true;
      }

      return _react2.default.createElement(
        _styles.SelectWrapper,
        {
          className: className,
          innerRef: function innerRef(ref) {
            _this2.root = ref;
          }
        },
        _react2.default.createElement(
          _styles.InputContainer,
          { onClick: this.toggleOpen },
          _react2.default.createElement(
            _styles.SelectInput,
            null,
            isEmptyValue ? _react2.default.createElement(
              _styles.Placeholder,
              null,
              placeholder
            ) : _react2.default.createElement(
              _styles2.InputLabel,
              null,
              label
            ),
            _react2.default.createElement(
              _styles.InputRight,
              { hasClear: !hideClear },
              !hideClear && _react2.default.createElement(_nitroIcon2.default, {
                name: 'close',
                variant: 'base2',
                size: 8,
                action: this.clearSelected,
                left: 'auto',
                right: 15,
                top: 'auto',
                bottom: 'auto'
              }),
              _react2.default.createElement(_nitroIcon2.default, {
                name: iconName,
                size: 8,
                variant: 'secondary',
                pointerEvents: 'none',
                left: 'auto',
                right: 'auto',
                top: 'auto',
                bottom: 'auto'
              })
            )
          )
        ),
        this.state.open && _react2.default.createElement(
          _styles.ListContainer,
          { maxHeight: containerMaxHeight },
          options.map(function (option) {
            var handleClick = function handleClick() {
              return _this2.handleOptionSelect(option);
            };

            return _react2.default.createElement(
              _styles.ListItem,
              { key: 'option-' + option.value, onClick: handleClick, active: option.value === value },
              option.label
            );
          })
        ),
        disabled && _react2.default.createElement(_utils.DisableCover, null)
      );
    }
  }]);

  return NitroSingleSelect;
}(_react.Component);

NitroSingleSelect.propTypes = {
  action: _propTypes2.default.func,
  className: _propTypes2.default.string,
  containerMaxHeight: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  mandatory: _propTypes2.default.bool,
  options: _propTypes2.default.array.isRequired,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

NitroSingleSelect.defaultProps = {
  action: function action() {
    return null;
  },
  containerMaxHeight: '200px',
  options: []
};

exports.default = NitroSingleSelect;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-single-select/NitroSingleSelect.js
// module id = 3035
// module chunks = 4